import { createProgressId } from './orchestrationProgress';

const MESSAGES = Object.freeze({
  queued: 'Tu consulta está en espera para comenzar.',
  conversation_agent: 'Comprendiendo tu consulta y el contexto de la conversación.',
  authorized_documents: 'Buscando información en los reportes autorizados.',
  document_analyst_agent: 'Analizando la evidencia recuperada.',
  evidence_reranking:'Ordenando las páginas por su pertinencia para tu consulta.',
  corrective_retrieval:'Recuperando páginas adicionales para verificar la información pendiente.',
  validated_output: 'Comprobando las cifras y sus fuentes.',
  commercial_advisor_agent: 'Desarrollando la propuesta comercial.',
  final_validation: 'Revisando la respuesta y las cifras antes de entregarlas.',
  completed: 'Respuesta lista.',
  failed: 'No fue posible completar el análisis.'
});
export function commercialProgress(body, id) {
  const s=body?.orchestration;
  if(s?.version!==3 || s?.delivery!=='async' || s.progress_id!==id ||
      !['processing','completed','failed'].includes(s.status) || !Array.isArray(s.steps)) return null;
  const steps=s.steps.slice(0,10).filter(x=>Object.hasOwn(MESSAGES,x?.stage) &&
    ['in_progress','completed','failed'].includes(x?.status)).map(x=>({stage:x.stage,status:x.status,message:MESSAGES[x.stage]}));
  return {version:3,delivery:'async',progress_id:id,status:s.status,steps};
}
const pause = (ms, signal) => new Promise((resolve,reject)=>{
  const stop=()=>{clearTimeout(timer);reject(new DOMException('Aborted','AbortError'));};
  const timer=setTimeout(()=>{signal?.removeEventListener('abort',stop);resolve();},ms);
  if(signal?.aborted) stop(); else signal?.addEventListener('abort',stop,{once:true});
});

export async function requestCommercialChat({url,statusUrl,payload,getToken,onProgress,signal,
  fetchImpl=fetch,progressId=createProgressId(),intervalMs=1500,maxDurationMs=260000}) {
  const started=Date.now();
  async function post(target, body) {
    if(signal?.aborted) throw new DOMException('Aborted','AbortError');
    const token=getToken();
    if(!token) throw new Error('Tu sesión terminó. Inicia sesión para continuar.');
    const controller=new AbortController();
    const abort=()=>controller.abort();
    signal?.addEventListener('abort',abort,{once:true});
    const timeout=setTimeout(abort,30000);
    try {
      const response=await fetchImpl(target,{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},
        body:JSON.stringify(body),cache:'no-store',signal:controller.signal});
      if(response.status===401 || response.status===403) throw new Error('Tu sesión terminó o ya no tienes permisos para esta consulta.');
      const data=await response.json().catch(()=>null);
      if(signal?.aborted) throw new DOMException('Aborted','AbortError');
      return {response,data};
    } finally {clearTimeout(timeout);signal?.removeEventListener('abort',abort);}
  }
  const first=await post(url,{...payload,delivery:'async',progress_id:progressId});
  if(!first.response.ok) throw new Error('No pude iniciar la consulta. Intenta nuevamente.');
  if(first.response.status!==202) return first.data; // Compatible with a server that still uses synchronous delivery.
  if(first.data?.delivery!=='async' || first.data.progress_id!==progressId) throw new Error('No pude confirmar el inicio del análisis.');
  const initial=commercialProgress(first.data,progressId);
  if(initial) onProgress(initial);
  while(!signal?.aborted && Date.now()-started<maxDurationMs) {
    await pause(intervalMs,signal);
    let next;
    try { next=await post(statusUrl,{progress_id:progressId}); }
    catch(error) {
      if(signal?.aborted || /sesión|permisos/.test(error.message)) throw error;
      continue; // Reconnect to the SAME job; never resubmit the question.
    }
    if(next.response.status===404) throw new Error('El análisis ya no está disponible o cambió tu acceso. Envía una nueva consulta.');
    if(!next.response.ok) continue;
    const snapshot=commercialProgress(next.data,progressId);
    if(!snapshot) throw new Error('No pude verificar el estado del análisis.');
    onProgress(snapshot);
    if(['completed','failed'].includes(snapshot.status)) {
      if(!next.data.result || typeof next.data.result.answer!=='string') throw new Error('No pude recuperar el resultado del análisis.');
      return next.data.result;
    }
  }
  if(signal?.aborted) throw new DOMException('Aborted','AbortError');
  throw new Error('El análisis superó el tiempo disponible. Puedes enviar una nueva consulta.');
}
